<template>
  <div class="map-container" :class="{ 'hide-draw': hideControl }">
    <div class="control-box">
      <div style="display: flex">
        <input
          v-model="postalcode"
          type="text"
          class="form-control portal-code-search"
          placeholder="Search Postal Code"
        />
        <div class="search-btn" @click="checkPostalCode">check</div>
        <div
          v-if="inside !== null"
          :class="{ inside: inside, outside: !inside }"
          style="
            display: flex;
            align-content: space-around;
            align-items: center;
            margin: 0px 20px;
          "
        >
          {{
            inside
              ? `'${postalcode}' is inside this boundary`
              : `'${postalcode}' is outside this boundary`
          }}
        </div>
      </div>
    </div>
    <div id="map"></div>
  </div>
</template>

<script>
import maplibregl from "maplibre-gl";
import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";
import axios from "axios"; // Assuming axios for HTTP requests
import * as turf from "@turf/turf";

export default {
  name: "MapComponent",
  props: {
    boundaries: {
      type: Array,
      default: () => {
        return [
          { lng: -0.37734068630607, lat: 51.57996415716278 },
          { lng: -0.3747228503071369, lat: 51.58000415994047 },
          { lng: -0.37182606457130873, lat: 51.58016417069908 },
          { lng: -0.37062443493277897, lat: 51.58036418335462 },
          { lng: -0.3674057841149079, lat: 51.579870817211344 },
          { lng: -0.3712467074242909, lat: 51.5771905453889 },
          { lng: -0.37429369686481095, lat: 51.576710480013304 },
          { lng: -0.3756240725361977, lat: 51.5768038264556 },
          { lng: -0.3769759058802151, lat: 51.57700385390109 },
          { lng: -0.37822045086255685, lat: 51.57725722073468 },
          { lng: -0.3801730990254555, lat: 51.57767060569378 },
          { lng: -0.38231886623762534, lat: 51.578163995723514 },
          { lng: -0.38195408581174206, lat: 51.5790040799354 },
          { lng: -0.381696593746085, lat: 51.58021750749327 },
          { lng: -0.37734068630607, lat: 51.57996415716278 },
        ];
      },
    },
  },
  data() {
    return {
      map: null,
      draw: null,
      polygonDrawn: false,
      drawingActive: false,
      boundries: [],
      hideControl: true,
      postalcode: "",
      inside: null,
    };
  },
  mounted() {
    this.initializeMap();
  },
  methods: {
    checkPostalCode() {
      this.inside = null;
      axios
        .get(
          `https://api.postcodes.io/postcodes/${encodeURIComponent(
            this.postalcode
          )}`
        )
        .then((response) => {
          const { latitude, longitude } = response.data.result;
          const point = turf.point([longitude, latitude]);
          const isInBoundary = this.checkIfInsideBoundary(point);
          this.inside = isInBoundary;
        })
        .catch((error) =>
          console.error("Error fetching postcode data: ", error)
        );
    },
    checkIfInsideBoundary(point) {
      // Assume boundary data is already added to the map source named 'boundary'
      const boundaryData = this.map.getSource("boundary")._data;
      const polygon = turf.polygon(
        boundaryData.features[0].geometry.coordinates
      );
      return turf.booleanPointInPolygon(point, polygon);
    },
    initializeMap() {
      this.map = new maplibregl.Map({
        container: "map",
        style: {
          version: 8,
          sources: {
            "osm-tiles": {
              type: "raster",
              tiles: ["https://tile.openstreetmap.org/{z}/{x}/{y}.png"],
              tileSize: 256,
              attribution: "",
            },
          },
          layers: [
            {
              id: "osm-tiles",
              type: "raster",
              source: "osm-tiles",
            },
          ],
        },
        center: [-2.305039, 54.131467],
        zoom: 4,
      });

      this.map.on("load", () => {
        if (this.boundaries) {
          this.loadBoundaries(this.boundaries);
        }
      });
    },
    loadBoundaries(boundaries) {
      const feature = {
        type: "Feature",
        properties: {},
        geometry: {
          type: "Polygon",
          coordinates: [boundaries.map((coord) => [coord.lng, coord.lat])],
        },
      };

      if (this.map.getSource("boundary")) {
        this.map.getSource("boundary").setData({
          type: "FeatureCollection",
          features: [feature],
        });
      } else {
        this.map.addSource("boundary", {
          type: "geojson",
          data: {
            type: "FeatureCollection",
            features: [feature],
          },
        });

        this.map.addLayer({
          id: "boundary",
          type: "fill",
          source: "boundary",
          layout: {},
          paint: {
            "fill-color": "blue",
            "fill-opacity": 0.4,
          },
        });
        // Line layer for polygon outline
        this.map.addLayer({
          id: "boundary-stroke",
          type: "line",
          source: "boundary",
          layout: {},
          paint: {
            "line-color": "black",
            "line-width": 3,
          },
        });
      }

      // Fit the map to the polygon bounds
      const bounds = new maplibregl.LngLatBounds();
      feature.geometry.coordinates[0].forEach((coord) => bounds.extend(coord));
      this.map.fitBounds(bounds, {
        padding: 20,
      });
    },
    convertAndSetBoundaries(inputCoords) {
      console.log("coordinates", JSON.stringify(inputCoords));
      if (Array.isArray(inputCoords) && inputCoords.length) {
        const coordinates = inputCoords[0].map((coord) => ({
          lng: coord[0],
          lat: coord[1],
        }));
        console.log("converted corrdinates", coordinates);
        this.updateValue(this.item_key, coordinates);
      }
    },
    boundriesToMapBoundry(inputData) {
      return [inputData.map((coord) => [coord.lng, coord.lat])];
    },
  },
};
</script>

<style>
.map-container {
  position: relative;
  margin-top: 20px;
  width: 100%;
  height: 480px;
}

#map {
  width: 100%;
  height: 400px;
  position: relative;
}

.control-box {
  top: 10px;
  right: 10px;
  display: flex;
  padding: 15px 0px;
  text-align: center;
  z-index: 1; /* Ensures the button box is above the map */
  cursor: pointer;
  color: #007cff;
  text-align: right;
  justify-content: space-between;
}

.maplibregl-control-container {
  position: absolute;
  top: 0;
  right: 0;
}

.canvas.maplibregl-canvas {
  position: relative;
}

.mapboxgl-ctrl-group.mapboxgl-ctrl {
  right: 0;
  position: absolute;
  top: 0;
}

.maplibregl-ctrl-bottom-right {
  display: none;
}
.hide-draw .mapboxgl-ctrl-group.mapboxgl-ctrl {
  display: none;
}
.portal-code-search {
  width: 300px;
  border-radius: 0px;
}
.control-box {
  display: flex;
  align-items: center;
  gap: 10px; /* Space between elements */
}

.search-btn,
.clear-btn {
  padding: 8px 12px; /* Padding for better touch area */
  background-color: #e2e2e2; /* Gray background */
  color: black; /* Color for the text and icon */
  font-size: 16px; /* Adjust size as needed */
  cursor: pointer; /* Cursor to pointer to indicate it's clickable */
  border: 1px solid #cccccc; /* Remove any default border */
  border-radius: 0px; /* Optional: rounded corners */
  height: 39px;
}

.search-btn:hover,
.clear-btn:hover {
  background-color: #bbb; /* Darker shade on hover */
}

.portal-code-search {
  flex-grow: 1; /* Allows the input to take up remaining space */
  padding: 8px;
  border: 1px solid #ccc;
}
.inside {
  color: green;
}
.outside {
  color: red;
}
</style>
